import {
  Group,
  Switch as MantineSwitch,
  SwitchProps,
  Text,
} from "@mantine/core";
import { SidebarInputProps } from "./types";

export const InputToggle = ({
  labelWidth = 228,
  label,
  size = "md",
  gap = 8,
  ...props
}: SidebarInputProps &
  SwitchProps & {
    gap?: number;
  }) => {
  //const [isModelShared] = useIsModelReadOnly();

  return (
    <Group h={36} gap={gap}>
      <Text
        style={{
          fontWeight: 500,
          fontSize: size === "md" ? 14 : "",
        }}
        size={size}
        w={labelWidth}
        mr={"auto"}
        component="div"
      >
        {label}
      </Text>
      <MantineSwitch
        //disabled={isModelShared}
        labelPosition="left"
        size={size}
        {...props}
        label={
          <div
            style={{
              width: 0,
              height: 0,
              overflow: "hidden",
              position: "absolute",
              left: -9999,
            }}
          >
            {label}
          </div>
        }
      />
    </Group>
  );
};
